/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import { getWeeks, getQuarters, getMonths, getYears, flagActive } from '../../_common/js/date-picker/utils.js';
import '../../_chunks/dep-2acfafca.js';
import '../../_chunks/dep-46de7b2e.js';
import 'react';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../config-provider/ConfigContext.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../_chunks/dep-fdce1f4f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_chunks/dep-c00532d4.js';

function useTableData(props) {
  var _useLocaleReceiver = useLocaleReceiver("datePicker"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    local = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var monthLocal = t(local.months);
  var quarterLocal = t(local.quarters);
  var start = props.start,
    end = props.end,
    hoverStart = props.hoverStart,
    hoverEnd = props.hoverEnd,
    year = props.year,
    month = props.month,
    mode = props.mode,
    firstDayOfWeek = props.firstDayOfWeek,
    disableDate = props.disableDate,
    minDate = props.minDate,
    maxDate = props.maxDate,
    isRange = props.isRange;
  var data = [];
  var options = {
    minDate: minDate,
    maxDate: maxDate,
    disableDate: disableDate,
    firstDayOfWeek: firstDayOfWeek,
    monthLocal: monthLocal,
    quarterLocal: quarterLocal,
    showWeekOfYear: mode === "week",
    dayjsLocale: local.dayjsLocale
  };
  if (mode === "date") {
    data = getWeeks({
      year: year,
      month: month
    }, options);
  } else if (mode === "week") {
    data = getWeeks({
      year: year,
      month: month
    }, options);
  } else if (mode === "quarter") {
    data = getQuarters(year, options);
  } else if (mode === "month") {
    data = getMonths(year, options);
  } else if (mode === "year") {
    data = getYears(year, options);
  }
  return flagActive(data, {
    start: start,
    end: end,
    hoverStart: hoverStart,
    hoverEnd: hoverEnd,
    type: mode,
    isRange: isRange
  });
}

export { useTableData as default };
//# sourceMappingURL=useTableData.js.map
